import { UserApi } from "../../../common/constants/user-api";
import { getResponseData } from "../../../common/utils/api-utils";
import { getAppFlow } from "../utils/user-profile.util";

export async function getUserProfileQuestions() {
    const url = new URL(UserApi.getUserProfileQuestions);
    return await getResponseData(
      new Request(url.toString(), {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Flow': getAppFlow()
        },
      })
    );
  }
  